import index from './Satellite';

export default index;
